import React, { FC, useState } from 'react';

type EditorSectionNameProps = {
  className: string;
  onInputChange: (value: string) => unknown;
  value: string;
};

export const EditorSectionName: FC<EditorSectionNameProps> = ({ className, onInputChange, value }) => {
  const [currentValue, setCurrentValue] = useState(value);
  const onChange = (e: any) => {
    setCurrentValue(e.target.value);
    onInputChange(e.target.value);
  };
  return <input className={className} value={currentValue} onChange={onChange} />;
};
